import isArray from 'lodash/isArray';
import sortBy from 'lodash/sortBy';
import React from 'react';
import { isNumOrStr } from '../../../utils/isNumOrStr';
import { TooltipWrapper } from '../utils/Utils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const defaultFormatter = (value: any): string =>
  isArray(value) && isNumOrStr(value[0]) && isNumOrStr(value[1])
    ? value.join(' ~ ')
    : value;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const WeightTooltip = (props: any): React.ReactElement => {
  const { payload, separator, formatter, itemStyle, itemSorter } = props;

  if (payload && payload.length) {
    const listStyle = { padding: 0, margin: 0 };

    const items = (itemSorter ? sortBy(payload, itemSorter) : payload).map(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (entry: any, i: number): React.ReactElement => {
        if (entry.type === 'none') {
          return null;
        }
        const finalItemStyle = {
          display: 'block',
          color: 'var(--color-text)',
          ...itemStyle,
        };
        const finalFormatter = entry.formatter || formatter || defaultFormatter;
        let { name, value } = entry;
        if (finalFormatter) {
          const formatted = finalFormatter(value, name, entry, i);
          if (Array.isArray(formatted)) {
            [value, name] = formatted;
          } else {
            value = formatted;
          }
        }
        const units = entry?.payload?.units;

        return (
          <React.Fragment key={`tooltip-item-${i}`}>
            <li className='recharts-tooltip-item' style={finalItemStyle}>
              {isNumOrStr(name) ? (
                <span className='recharts-tooltip-item-name'>{name}</span>
              ) : null}
              {isNumOrStr(name) ? (
                <span className='recharts-tooltip-item-separator'>
                  {separator}
                </span>
              ) : null}
              <span className='recharts-tooltip-item-value'>{value}</span>
              <span className='recharts-tooltip-item-unit'>
                {(name !== 'Date' && units) || ''}
              </span>
            </li>
          </React.Fragment>
        );
      }
    );

    return (
      <TooltipWrapper>
        <ul className='recharts-tooltip-item-list' style={listStyle}>
          {items}
        </ul>
      </TooltipWrapper>
    );
  }

  return null;
};
